import { render, staticRenderFns } from "./InfrastructureTypeView.vue?vue&type=template&id=fc0ce812&scoped=true"
import script from "./InfrastructureTypeView.vue?vue&type=script&lang=js"
export * from "./InfrastructureTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0ce812",
  null
  
)

export default component.exports